const refresh = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M15 7V1.81l-1.85 1.85A6.74 6.74 0 1 0 8 14.75a6.57 6.57 0 0 0 2.44-.46l.32-.13a7 7 0 0 0 1.16-.66l.33-.26a3.47 3.47 0 0 0 .29-.25l.18-.17c.14-.13.26-.26.39-.4a7.23 7.23 0 0 0 .73-1c.07-.12.14-.24.2-.36l-1.35-.67a2.44 2.44 0 0 1-.14.28 5.61 5.61 0 0 1-.58.8 3 3 0 0 1-.3.32l-.13.13-.24.2-.25.2c-.285.2-.59.372-.91.51l-.24.11a5.33 5.33 0 0 1-1.9.35 5.25 5.25 0 1 1 4.09-8.53L9.81 7z"/></svg>',
};

export { refresh as default };
